import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { getEmployeesInvolved } from "../../stakeholder/logic/stakeholderSlice";
import ManagementModal from "../../../components/ui/modals/ManagementModal";
import { EmployeeRow } from "./EmployeeModal";

interface EmployeeManageModalProps {
  onClose: () => void;
  onBack?: () => void;
}

const EmployeeManageModal: React.FC<EmployeeManageModalProps> = ({
  onClose,
  onBack,
}) => {
  const employees = useAppSelector(getEmployeesInvolved);
  const handleBack = onBack ?? onClose;

  return (
    <ManagementModal
      title="Manage Employees"
      onClose={onClose}
      onBack={handleBack}
      onSubmit={() => {}}
      onCancel={onClose}
      cancelLabel="Discard"
      submitEnabled={false}
      className="w-[932px] max-w-[80vw]"
    >
      <div className="flex max-h-[50vh] flex-col gap-4 overflow-y-auto pr-1">
        {employees.map((employee) => (
          <EmployeeRow
            key={employee.stakeholderId}
            type={employee.relatedAs}
            name={employee.name}
            employeeId={employee.employeeId}
          />
        ))}
      </div>
    </ManagementModal>
  );
};

export default EmployeeManageModal;